module.exports = __webpack_public_path__ + "img/flag-mexico.e8fa745.svg";